import I18n from './i18n';
I18n.translations || (I18n.translations = {});
I18n.translations['th'] = I18n.extend(
  I18n.translations['th'] || {},
  JSON.parse(
    '{"japan_concierge":{"active_plans":{"map_menu":{"map_menu_select_month_title":"เลือกเดือน","map_menu_select_season_title":"เลือกฤดูกาล"},"map_menu_header":{"attraction":"แหล่งท่องเที่ยว","event":"เหตุการณ์ที่เกิดขึ้น"}}}}'
  )
);
